import React from 'react';
import { Card } from 'bumbag';
import _get from 'lodash/get';

import { withRouter } from '@medipass/react-core/router';
import sdk from '@medipass/web-sdk';

import HealthFundAccountForm from 'legacy/components/account/health-fund-accounts/HealthFundAccountForm';
import Page from 'legacy/components/account/layout/Page';
import WithAuthentication from 'legacy/components/WithAuthentication';
import { updateMembersHealthFundAccount } from 'legacy/utils/health-fund-accounts';
type Props = {
  history: Record<string, any>;
};

class CreateHealthFundAccount extends React.PureComponent<Props> {
  handleAddHealthFundAccount = async (healthFundAccount: Record<string, any>) => {
    const { history } = this.props;

    const memberId = _get(sdk, 'member._id');

    const body = await updateMembersHealthFundAccount({
      healthFundAccount,
      memberId,
    });
    history.push('/account/members');
    return body;
  };
  handleClickCancel = () => {
    window.history.back();
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="Add health fund">
        <Card>
          <HealthFundAccountForm
            onClickCancel={this.handleClickCancel}
            onSubmit={this.handleAddHealthFundAccount}
            title="Add health fund"
            runVerifyMember={false}
          />
        </Card>
      </Page>
    </WithAuthentication>
  );
}

export default withRouter(CreateHealthFundAccount);
